//import {Row} from 'antd';
import {
  Row,
  // Col,
  Form,
  Input,
  // Space,
  // Button,
  // DatePicker,
  Select,
  // InputNumber,
  // message,
  // Modal,
} from "antd";

import classes from "../Pages.module.css";
import DataField from "./DataField";
import axios from "axios";
// import EmployeeTable from "../EmployeeTable/EmployeeTable";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useState, useContext, useEffect } from "react";
import DataContext from "../../../Context/dataContext";

const { Option } = Select;

const SizeDetail = (props) => {


  console.log(props, "props in grade");
  const { outwardDetails, data, setData } = props;
  //   // console.log(props, "props in sizedetail");
  //   // console.log(props, "props in sizedetail");
  const employeeData = useContext(DataContext);
  const [sizef, setSizef] = useState([]);
  const [gradef, setGradef] = useState([]);
  const [uomf, setUomf] = useState([]);
  // const [cost, setCost] = useState([]);
  const [edi, setEdi] = useState(false);
  // const [itemindex, setItemindex] = useState();
  // const [deletedIndex, setDeletedIndex] = useState(null);
  // const pcsRef = useRef(null);
  // const [totalQuantity, setTotalQuantity] = useState(0); // State to hold total quantity sum
  // const [isModalVisible, setIsModalVisible] = useState(false);
  // const sizeRef = useRef(null);
  const [form] = Form.useForm();


  useEffect(() => {
    if (outwardDetails && outwardDetails.rows && outwardDetails.rows.length > 0) {
      console.log("useEffect triggered with outward:", outwardDetails);

      // Assuming there is only one row in outwardDetails
      const outwardRow = outwardDetails.rows[0];





      // Prepare updated data for form fields
      const updatedProdDetail = data.map((detail) => ({
        ...detail,
        item_code: outwardRow.item_code,
        grade: outwardRow.grade,
        grade_desc:outwardRow.quality,
        uom_code: outwardRow.uom_code,
        uom:outwardRow.uom,
        size_code: outwardRow.size_code,
        size_desc:outwardRow.size_desc,
        pcs: outwardRow.pcs,
        total: outwardRow.total,
        hsn: outwardRow.hsn,
        rate: outwardRow.rate,
        burning: outwardRow.burning,
        wt: outwardRow.net_wt1,
        total_2: outwardRow.total_2,
        ppc_out: outwardDetails.outward_code,


      }));

      // Update state
      setData((prevData) => ({
        ...prevData,
        prodDetail: updatedProdDetail,
        
      }));

      // Update form fields
      form.setFieldsValue({
        prodDetail: updatedProdDetail,
      });
    }
  }, [outwardDetails]);


  const handleValueChanges = (changedValues, allValues) => {
    props.setData((data) => {
      return {
        ...data,
        prodDetail: allValues.prodDetail,
        // invoiceSize1: changedValues.invoiceSize,
      };
    });
  };

  // const handleVoucherDetailChange = (changedValue, changedName) => {
  //   console.log(changedValue, changedName);
  //   // Check if changedValue and changedName are defined before proceeding
  //   // if (changedValue === undefined || changedName === undefined) {
  //   //   console.error("Changed value or name is undefined");
  //   //   return; // Exit early if either value is undefined
  //   // }

  //   // Update the specific VoucherDetail field with the new value
  //   setData((prevData) => {
  //     console.log(prevData);

  //     // Map over the prodDetail array and update the relevant item
  //     const updatedVoucherDetail = prevData.prodDetail.map((item, index) => {
  //       if (index === changedName) {
  //         return {
  //           ...item,
  //           net_amount: changedValue, // Update the 'net_amount' field for the specific item
  //         };
  //       }
  //       return item;
  //     });

  //     console.log(updatedVoucherDetail, "Updated Voucher Detail");

  //     // Calculate the new totals for credit and debit
  //     const { totalCr } = calculateTotals(updatedVoucherDetail);

  //     // Return the updated state with the new VoucherDetail and VoucherHeader
  //     return {
  //       ...prevData,
  //       prodDetail: updatedVoucherDetail,
  //       prodHdr: [
  //         {
  //           ...prevData.prodHdr[0],
  //           net_amount: totalCr,
  //         },
  //       ],
  //     };
  //   });
  // };

  const handlechangee1 = async (changedValues, allValues, i) => {
    // console.log(i, "after item change");
    // // console.log(i, "after item change");
    // setItemindex(i);
    setEdi(true);
    // // console.log(pcsRef.current.value);
    setSizef(sizef);
    const values = form.getFieldsValue(["prodDetail"]);

    // console.log(values);
    // Check if Mode is true or present, then set it to false
    // if (props.data[i].Mode === true) {
    //   props.data[i].Mode = false;
    // }
    values.prodDetail[i].Mode = false;
    values.prodDetail[i].size_code = null;
    values.prodDetail[i].uom_code = null;
    values.prodDetail[i].quality_code = null;
    values.prodDetail[i].hsn = null;
    values.prodDetail[i].grade = null;

    form.setFieldsValue(values);

    // pcsRef.current.value = null;
    // sizeRef.current.value = null;

    props.setData((data) => {
      // console.log(data);
      // console.log(data);

      axios
        .get(
          employeeData.URL +
          "/api/v1/jobwork/additional-data-of-hsn/ " +
          data.prodDetail[i].item_code,
          {
            withCredentials: true,
          }
        )

        .then((response) => {
          // console.log(response);
          const uomOptions = response.data.data.uom.rows.map((option) => ({
            label: option[response.data.data.uom.fields[1].name],
            value: option[response.data.data.uom.fields[0].name],
          }));
          const HsnValue = response.data.data.hsn1.rows[0].hsn;

          // Automatically set uom_code if there is only one option
          if (uomOptions.length === 1) {
            values.prodDetail[i].uom_code = uomOptions[0].value;
            values.prodDetail[i].hsn = HsnValue;
            form.setFieldsValue(values);
          }

          setUomf((prevUomf) => {
            const newUomf = [...prevUomf];
            newUomf[i] = uomOptions.map((option) => (
              <Option
                style={{ textTransform: "capitalize", color: "#1777C4" }}
                key={option.value}
                value={option.value}
              >
                {option.label}
              </Option>
            ));
            return newUomf;
          });

          setSizef((prevSizef) => {
            // console.log(prevSizef, " In the 83 line");
            const newSizef = [...prevSizef];
            newSizef[i] = response.data.data.size.rows.map((option) => (
              <Option
                style={{ textTransform: "capitalize", color: "#1777C4" }}
                key={option[response.data.data.size.fields[0].name]}
                value={option[response.data.data.size.fields[0].name]}
              >
                {option[response.data.data.size.fields[1].name]}
              </Option>
            ));
            // console.log(newSizef);
            return newSizef;
          });

          setGradef((prevGradef) => {
            const newGradef = [...prevGradef];
            newGradef[i] = response.data.data.grade.rows.map((option) => (
              <Option
                style={{ textTransform: "capitalize", color: "#1777C4" }}
                key={option[response.data.data.grade.fields[0].name]}
                value={option[response.data.data.grade.fields[0].name]}
              >
                {option[response.data.data.grade.fields[1].name]}
              </Option>
            ));
            return newGradef;
          });


        });

      return {
        ...data,
      };
    });
  };

  console.log(outwardDetails, "outward details is present");
  return props.editMode ? (
    <Form
      layout="vertical"
      name="filter_form"
      onValuesChange={handleValueChanges}
      autoComplete="off"
      form={form}
    >
      <div className="component-container">
        <Form.List name="prodDetail" initialValue={props.data}>
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }, i) => (
                  <table
                    id="table_order"
                    className="table table-bordered"
                    style={{
                      tableLayout: "fixed",
                      width: "1250px",
                      marginBottom: "-2rem",
                    }}
                  >
                    {i === 0 && (
                      <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                        <tr
                          style={{
                            height: "0.4rem",
                            backgroundColor: "rgb(217 217 217 / 35%)",
                          }}
                        >
                          <th style={{ width: "12%" }}>
                            {" "}
                            Item{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th>
                          <th style={{ width: "5.5%" }}>
                            {" "}
                            Hsn{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th>

                          <th style={{ width: "7%" }}>
                            Size{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th>

                          <th style={{ width: "7%" }}>
                            Grade{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th>

                          <th style={{}}>
                            Uom{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th>


                          {/* <th style={{}}>
                            Type{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th>
                          
                          <th style={{}}>
                            Reference Service{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th> */}

                          {/* <th style={{}}>
                            Run Type{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th> */}
                          {/* <th style={{}}>
                            Entry Type{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th> */}
                          <th style={{}}>Pcs</th>

                          <th style={{}}>Actual Weight</th>
                          <th style={{}}>Rate</th>
                          <th style={{}}>Total</th>
                          <th style={{}}>Burning Loss</th>
                          <th style={{}}>Net Weight</th>
                          <th style={{}}>Net Total Amount</th>
                          <th style={{ width: "8%", textAlign: "left" }}>#</th>
                        </tr>
                      </thead>
                    )}

                    <tbody
                    // style={{
                    //   width: "12%",
                    //   height: "10px",
                    //   // border: "2px solid black",
                    // }}
                    >
                      <tr
                        style={
                          {
                            // border: "2px solid red",
                          }
                        }
                      >
                        <td
                          style={{
                            width: "12%",
                            // height: "10px",
                            border: "1px solid white",
                          }}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "item_code"]}
                            fieldKey={[fieldKey, "item_code"]}
                            rules={[
                              { required: true, message: "Missing Name" },
                            ]}
                          >
                            <Select
                              showSearch
                              // open={openStates[`item_code_${i}`]}
                              bordered={true}
                              // onDropdownVisibleChange={(visible) =>
                              //   handleDropdownVisibleChange(
                              //     visible,
                              //     i,
                              //     "item_code"
                              //   )
                              // }
                              
                              onChange={(changedValues, allValues) =>
                                handlechangee1(changedValues, allValues, i)
                              }
                              style={{
                                width: "110%",
                                textAlign: "left",
                                backgroundColor: "white",
                                color: "#1777C4",
                                fontWeight: "bold",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              placeholder="Select Item"
                              disabled={true}
                              optionFilterProp="children"
                            >
                              {props.ad.ITEM_CODE.rows.map((option) => {
                                return (
                                  <Option
                                    style={{
                                      textTransform: "capitalize",
                                      color: "#1777C4",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    key={
                                      option[props.ad.ITEM_CODE.fields[0].name]
                                    }
                                    value={
                                      option[props.ad.ITEM_CODE.fields[0].name]
                                    }
                                  >
                                    {option[props.ad.ITEM_CODE.fields[0].name]}{" "}
                                    {option[props.ad.ITEM_CODE.fields[1].name]}

                                  </Option>
                                );

                              })}
                            </Select>
                          </Form.Item>
                        </td>

                        <td
                          style={{
                            width: "5.5%",
                            textAlign: "right",
                            border: "1px solid white",
                          }}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "hsn"]}
                            fieldKey={[fieldKey, "hsn"]}

                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              placeholder="hsn"
                              step={0.01}
                              decimalScale={2}
                              type="number"
                              min={0}
                              disabled={true}

                            />
                          </Form.Item>
                        </td>


                        <td
                          style={{ border: "1px solid white", width: "7%" }}
                        >
                     
                          <Form.Item
                            {...restField}
                            name={[name, "size_desc"]}
                            fieldKey={[fieldKey, "size_code"]}
                          >
                          
                            <Select
                              showSearch



                              bordered={true}

                              style={{
                                width: "100%",
                                textAlign: "left",
                                float: "left",
                                backgroundColor: "white",
                                color: "#1777C4",
                                fontWeight: "bold",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // ref={props.sizeRef}
                              id="sizewala"
                              placeholder="Select Size"
                              optionFilterProp="children"
                              disabled={true}
                            >
                              {props.data[i]?.Mode !== undefined &&
                                (props.data[i]?.Mode
                                  ? props.responseDataArray[i]?.size.rows.map(
                                    (option) => (
                                      <Option
                                        style={{
                                          textTransform: "capitalize",
                                          color: "#1777C4",
                                        }}
                                        key={
                                          option[
                                          props.responseDataArray[i].size
                                            .fields[0].name
                                          ]
                                        }
                                        value={
                                          option[
                                          props.responseDataArray[i].size
                                            .fields[0].name
                                          ]
                                        }
                                      >
                                        {
                                          option[
                                          props.responseDataArray[i].size
                                            .fields[1].name
                                          ]
                                        }
                                      </Option>
                                    )
                                  )
                                  : edi
                                    ? sizef[i]
                                    : null)}
                            </Select>
                          </Form.Item>
                        </td>

                        <td
                          style={{ border: "1px solid white", width: "7%" }}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "grade_desc"]}
                            fieldKey={[fieldKey, "grade"]}
                          >
                            <Select
                              showSearch

                              // onKeyDown={(e) =>
                              //   handleKeyDown(e, i, "quality_code")
                              // }

                              bordered={true}
                              disabled={true}
                              style={{
                                width: "100%",
                                textAlign: "left",
                                float: "left",
                                backgroundColor: "white",
                                color: "#1777C4",
                                fontWeight: "bold",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              placeholder="Select Grade"
                              optionFilterProp="children"

                            >
                              {props.data[i]?.Mode !== undefined &&
                                (props.data[i]?.Mode
                                  ? props.responseDataArray[
                                    i
                                  ]?.grade.rows.map((option) => (
                                    <Option
                                      style={{
                                        textTransform: "capitalize",
                                        color: "#1777C4",
                                      }}
                                      key={
                                        option[
                                        props.responseDataArray[i].grade
                                          .fields[0].name
                                        ]
                                      }
                                      value={
                                        option[
                                        props.responseDataArray[i].grade
                                          .fields[0].name
                                        ]
                                      }
                                    >
                                      {
                                        option[
                                        props.responseDataArray[i].grade
                                          .fields[1].name
                                        ]
                                      }
                                    </Option>
                                  ))
                                  : edi
                                    ? gradef[i]
                                    : null)}
                            </Select>
                          </Form.Item>
                        </td>



                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "uom"]}
                            fieldKey={[fieldKey, "uom_code"]}


                          >
                            <Select
                              bordered={true}
                              style={{
                                width: "80%",
                                textAlign: "left",
                                float: "left",
                                backgroundColor: "white",
                                color: "#1777C4",
                                fontWeight: "bold",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              placeholder="Select Uom"
                              optionFilterProp="children"
                            >

                              {props.data[i]?.Mode !== undefined &&
                                (props.data[i]?.Mode
                                  ? props.responseDataArray[i]?.uom.rows.map(
                                    (option) => (
                                      <Option
                                        style={{
                                          textTransform: "capitalize",
                                          color: "#1777C4",
                                        }}
                                        key={
                                          option[
                                          props.responseDataArray[i].uom
                                            .fields[0].name
                                          ]
                                        }
                                        value={
                                          option[
                                          props.responseDataArray[i].uom
                                            .fields[0].name
                                          ]
                                        }
                                      >
                                        {
                                          option[
                                          props.responseDataArray[i].uom
                                            .fields[1].name
                                          ]
                                        }
                                      </Option>
                                    )
                                  )
                                  : edi
                                    ? uomf[i]
                                    : null)}
                            </Select>
                          </Form.Item>
                        </td>


                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "pcs"]}
                            fieldKey={[fieldKey, "pcs"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                              placeholder="Pcs"
                              step={0.1}
                              // decimalScale={2}
                              type="number"
                              disabled={true}
                              min={0}
                            />
                          </Form.Item>
                        </td>


                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "total"]}
                            fieldKey={[fieldKey, "total"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                              placeholder="Actual Weight"
                              step={0.01}
                              decimalScale={2}
                              disabled={true}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                        </td>


                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "rate"]}
                            fieldKey={[fieldKey, "rate"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                              disabled={true}
                              placeholder="Enter Rate"
                              step={0.01}
                              decimalScale={2}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "total"]}
                            fieldKey={[fieldKey, "total"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                              disabled={true}
                              placeholder="total_amount"
                              step={0.01}
                              decimalScale={2}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "burning"]}
                            fieldKey={[fieldKey, "burning"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                              disabled={true}
                              placeholder="Enter Rate"
                              step={0.01}
                              decimalScale={2}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                        </td>
                        {/* 
                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "burning"]}
                            fieldKey={[fieldKey, "burning"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                             
                              placeholder="Enter Burning"
                              step={0.01}
                              decimalScale={2}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                        </td> */}

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "wt"]}
                            fieldKey={[fieldKey, "wt"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                              disabled={true}
                              // placeholder="Enter Burning"
                              step={0.01}
                              decimalScale={2}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "total_2"]}
                            fieldKey={[fieldKey, "total_2"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                              disable={true}
                              placeholder="Enter Burning"
                              step={0.01}
                              decimalScale={2}
                              type="number"
                              disabled={true}
                              min={0}
                            />
                          </Form.Item>
                        </td>
                        {/* onChange={handleChangee} */}
                        <td
                          style={{
                            border: "1px solid white",
                            // border: "2px solid red",
                            width: "8%",
                            textAlign: "left",
                          }}
                        >
                          <MinusCircleOutlined
                            className={classes["Remove"]}
                            onClick={() => { remove(name) }}
                          />

                          <PlusCircleOutlined
                            className={classes["Add"]}
                            onClick={() => {
                              add();
                            }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ))}
              </>
            );
          }}
        </Form.List>
      </div>
    </Form>
  ) : (
    <>
      {props.data.map((data, index) => {
        return (
          <div key={index}>
            <p></p>
            <Row
              className={props.editMode ? classes["RowDEX"] : classes["RowD"]}
            >
              <DataField
                editMode={false}
                lg={12}
                md={24}
                options={props.ad.ITEM_CODE}
                type="Select"
                name="Item"
                value={data.item_code}
              />
            </Row>
            <p></p>
          </div>
        );
      })}
    </>
  );
};

export default SizeDetail;
